/**
 * Accordéon « Caractéristiques » des fiches produits (blocks/product-notes.liquid).
 *
 * Un seul ouvert à la fois ; ouvrir une ligne joue le geste de son icône (classe `ico-joue`,
 * retirée à la fin du geste : l'icône redevient l'image d'origine sans aucun style d'animation,
 * comme sur la page Comparateur). Aucun défilement commandé : l'accordéon reste simple, la ligne
 * touchée remonte de la hauteur repliée pendant l'animation (retour iPhone du 06.10.2026).
 */
const REDUIT = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const DUREE_GESTE = 2600;
const DUREE_PLI = 350;

function initialiser(root) {
  if (root.dataset.pdlNotesReady) return;
  root.dataset.pdlNotesReady = '1';

  const items = Array.from(root.querySelectorAll('[data-pdl-notes-item]'));
  const minuteries = new Map();
  const finsGeste = new Map();

  const jouerGeste = (item) => {
    if (REDUIT) return;
    clearTimeout(finsGeste.get(item));
    item.classList.remove('ico-joue');
    void item.offsetWidth;
    item.classList.add('ico-joue');
    finsGeste.set(item, setTimeout(() => item.classList.remove('ico-joue'), DUREE_GESTE));
  };

  const fermer = (item) => {
    const btn = item.querySelector('[data-pdl-notes-btn]');
    const pan = item.querySelector('.pdl-notes__panneau');
    if (!btn || !pan || btn.getAttribute('aria-expanded') !== 'true') return;
    btn.setAttribute('aria-expanded', 'false');
    item.classList.remove('is-open', 'ico-joue');
    clearTimeout(minuteries.get(item));
    pan.classList.remove('is-open');
    if (REDUIT) {
      pan.hidden = true;
      return;
    }
    minuteries.set(item, setTimeout(() => { pan.hidden = true; }, DUREE_PLI));
  };

  const ouvrir = (item) => {
    const btn = item.querySelector('[data-pdl-notes-btn]');
    const pan = item.querySelector('.pdl-notes__panneau');
    if (!btn || !pan) return;
    clearTimeout(minuteries.get(item));
    btn.setAttribute('aria-expanded', 'true');
    item.classList.add('is-open');
    pan.hidden = false;
    // la hauteur part de 0fr une fois le panneau visible, sinon aucune transition
    void pan.offsetHeight;
    pan.classList.add('is-open');
    jouerGeste(item);
  };

  for (const item of items) {
    const btn = item.querySelector('[data-pdl-notes-btn]');
    if (!btn) continue;
    btn.addEventListener('click', () => {
      const estOuvert = btn.getAttribute('aria-expanded') === 'true';
      if (estOuvert) {
        fermer(item);
        return;
      }
      for (const autre of items) if (autre !== item) fermer(autre);
      ouvrir(item);
    });
  }

  // la première ligne est ouverte dans le balisage : son icône joue à l'arrivée dès qu'elle est visible
  const premiere = items.find((i) => i.classList.contains('is-open'));
  if (premiere && !REDUIT) {
    if ('IntersectionObserver' in window) {
      const obs = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          jouerGeste(premiere);
          obs.disconnect();
        }
      }, { threshold: 0.6 });
      obs.observe(premiere);
    } else {
      jouerGeste(premiere);
    }
  }
}

const demarrer = () => document.querySelectorAll('[data-pdl-notes]').forEach(initialiser);
demarrer();
// l'éditeur de thème et le changement de variante peuvent re-rendre la section
document.addEventListener('shopify:section:load', demarrer);
